const presentationsMutation = {
  setPresentations(state, payload) {
    state.presentations = payload
  },
}

export default presentationsMutation
